import { batchRequests } from '../../../utils/batch-requests';
import { getFetch } from '../fetch';
import { apiConfig } from '../config';

type ObjectID = number;

export interface GetCriteriaResponse {
    result: Record<ObjectID, Criteria[]>;
}

export interface Criteria {
    id: string;
    description: string;
    slug: string;
    name: string;
}

export function getCriteriaBatch(object_ids: ObjectID[]): Promise<GetCriteriaResponse> {
    const { apiGetCriteria } = apiConfig.getStaticUrls();

    return getFetch(apiGetCriteria, { object_ids, object_type: 'problem' });
}

export const getCriteria = batchRequests(
    getCriteriaBatch,
    (problemId, batchResponse) => batchResponse.result[problemId] || [],
);
